export const CORE_VALUES_KEY = 'zobu_core_values';

export interface CoreValue {
  id: string;
  icon: string;
  title: string;
  desc: string;
  order: number;
}

export const mockCoreValues: CoreValue[] = [
  { id: 'cv-1', icon: 'ri-scales-3-line', title: 'Integrity', desc: 'We act with full transparency and hold ourselves to the highest professional standards in every engagement.', order: 1 },
  { id: 'cv-2', icon: 'ri-user-heart-line', title: 'Client First', desc: 'Impartially on your side. Our only interest is delivering measurable, lasting value for you.', order: 2 },
  { id: 'cv-3', icon: 'ri-lightbulb-flash-line', title: 'Innovation', desc: 'We craft unique strategies, never off-the-shelf solutions. Every engagement starts from a blank page.', order: 3 },
  { id: 'cv-4', icon: 'ri-global-line', title: 'Global Perspective', desc: 'International experience combined with deep local market knowledge across Turkey and beyond.', order: 4 },
];

export const ICON_OPTIONS = [
  'ri-scales-3-line', 'ri-user-heart-line', 'ri-lightbulb-flash-line', 'ri-global-line',
  'ri-shield-check-line', 'ri-handshake-line', 'ri-award-line', 'ri-medal-line',
  'ri-star-line', 'ri-focus-3-line', 'ri-eye-line', 'ri-compass-line',
  'ri-team-line', 'ri-community-line', 'ri-heart-line', 'ri-empathize-line',
  'ri-bar-chart-2-line', 'ri-rocket-line', 'ri-leaf-line', 'ri-refresh-line',
  'ri-verified-badge-line', 'ri-briefcase-4-line', 'ri-map-2-line', 'ri-government-line',
];
